import { useState } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { FullPageLoading } from '@Components';
import { RootState } from '@Store';
import SplitLayout from './components/SplitLayout';

interface SupplierOnboardingProps {
  dataReady?: boolean;
  isConfigFetching?: boolean;
}

/**
 * Renders the "data is processing" view for a GS1 SMB provider mid-ingestion.
 *
 * Stays on this view only when `dataReady === false`. If the workspace is
 * already ready (`true`) or in any unknown state, redirect to `/monitor` so a
 * deep link / bookmark to `/onboarding` can't trap a non-provisioning user
 * here. The redirect is rendered synchronously via `<Navigate>` to avoid the
 * frame of UI flash that a `useEffect`-based redirect would leave behind.
 */
const SupplierOnboarding = ({ dataReady, isConfigFetching }: SupplierOnboardingProps) => {
  const [submitted, setSubmitted] = useState(false);

  if (isConfigFetching) return <FullPageLoading />;
  if (dataReady !== false) return <Navigate to="/monitor" replace />;

  return (
    <div className="flex-1 flex flex-col min-h-0 bg-background animate-es-fade-in">
      <SplitLayout submitted={submitted} onSubmit={() => setSubmitted(true)} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const client = state?.client;
  return {
    dataReady: client?.configuration?.dataReady,
    isConfigFetching: client?.isFetching,
  };
};

export default connect(mapStateToProps)(SupplierOnboarding);
